import TelecollectionQuery from "../../domain/core/payments/TelecollectionQuery";
import { TelecollectionModel } from "../../domain/models/Telecollection";
import { IQueryTelecollectionRepository } from "../../domain/ports/payments/IQueryTelecollectionRepository";
import QueryService from "../QueryService";

export class TelecollectionQueryService
  extends QueryService<TelecollectionModel>
  implements IQueryTelecollectionRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const telecollectionQuery = new TelecollectionQuery(
  new TelecollectionQueryService(BASE_URL, "telecollections"),
);

export { telecollectionQuery };
